import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserSession } from '../shared/user-session';

@Injectable()
export class RegistrationUtilService {
  reEnterContactInformation$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private userSession: UserSession) {
  }


  clearLocalStorageData() {
    let listOfRegItems = ['subscriberId', 'dateOfBirth', 'firstName', 'lastName', 'globalConsent', 'relationship', 'gender', 'MOSshop'];
    for (let clearObject of listOfRegItems) {
      this.userSession.setLocalStorageItem(clearObject, null);
    }
  }

  clearContactInformation() {
    this.userSession.setLocalStorageItem('RegEmailId', null);
    this.userSession.setLocalStorageItem('RegPhone', null);
    this.userSession.setSession('RegEmailId', null);
    this.userSession.setSession('RegPhone', null);
  }

  clearLoginInfo() {
    this.userSession.setLocalStorageItem('userId', null);
    this.userSession.setLocalStorageItem('password', null);
    this.userSession.setLocalStorageItem('ENpassword', null);
  }

  clearSessionData() {
    let listOfRegItems = ['zipCode', 'ssn', 'firstName', 'lastName', 'subscriberId', 'dateOfBirth', 'alternateID', 'university'];
    for (let clearObject of listOfRegItems) {
      this.userSession.setSession(clearObject, null);
    }
  }

  clearAllData() {
    this.clearLocalStorageData();
    this.clearContactInformation();
    this.clearLoginInfo();
    this.clearSessionData();
  }

  emailFormatChange(demail: string) {
    var email: string = demail;
    let start = email.split('@')
    return start[0][0] + new Array(start[0].length - 1).join("x") + start[0][start[0].length - 1] + '@' + start[1];

  }
  phoneNoMasked(memberPhoneNumber) {
    let number = memberPhoneNumber
    return '###-###-'
      + number.substr(number.length - 4, 4);
  }
}



// WEBPACK FOOTER //
// ./src/app/new-registration/registration-util.service.ts